export default __webpack_public_path__ + "fbd78912f82ed739a7bd1c1bec5b9375.woff";